export const REACT_EVENT_KEY_ENTER = 'Enter';
